import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const inputClass = 'w-full h-12 px-4 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors';
const labelClass = 'block text-sm font-semibold text-[#333] mb-1.5';
const helpOptions = ['Orientación nutricional', 'Acceso a especialistas biomédicos', 'Apoyo educativo', 'Recursos y materiales', 'Apoyo emocional para la familia', 'Otro'];
export function SolicitarAyuda() {
  useDocumentMeta({
    title: 'Solicitar Ayuda | Pancita Feliz Foundation',
    description: 'Solicita apoyo de Pancita Feliz Foundation. Ayudamos a familias con recursos limitados a acceder a educación y abordajes biomédicos.',
    path: '/solicitar-ayuda'
  });
  return <main className="w-full" data-id="element-360">
      {/* Hero */}
      <section className="text-center px-4 py-16" style={{
      background: '#f0f7e6'
    }} data-id="element-361">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/15 rounded-full mb-5" data-id="element-362">
          <HeartHandshakeIcon className="w-8 h-8 text-primary" data-id="element-363" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-364">
          Solicita Ayuda
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-365">
          Completa el formulario y nuestro equipo se pondrá en contacto contigo.
        </p>
      </section>

      {/* Form */}
      <section className="px-4 py-12 bg-white" data-id="element-366">
        <div className="mx-auto bg-white" style={{
        maxWidth: '680px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '48px'
      }} data-id="element-367">
          <form action="https://formspree.io/f/mjgqrwbz" method="POST" data-id="element-368">
            <input type="hidden" name="_replyto" value="info@pancitafelizfoundation.org" data-id="element-369" />
            <input type="hidden" name="_subject" value="🌱 Nueva Solicitud de Ayuda - Pancita Feliz Foundation" data-id="element-370" />

            <h2 className="text-[22px] font-bold text-[#1a1a1a] mb-8" data-id="element-371">
              Información de la Familia
            </h2>

            {/* Personal info */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4" data-id="element-372">
              Información Personal
            </p>

            <div className="mb-5" data-id="element-373">
              <label className={labelClass} data-id="element-374">
                Nombre completo del padre/madre/tutor
              </label>
              <input type="text" name="nombre_completo" required placeholder="Tu nombre completo" className={inputClass} data-id="element-375" />
            </div>

            <div className="mb-5" data-id="element-376">
              <label className={labelClass} data-id="element-377">Correo electrónico</label>
              <input type="email" name="email" required placeholder="correo@ejemplo.com" className={inputClass} data-id="element-378" />
            </div>

            <div className="mb-5" data-id="element-379">
              <label className={labelClass} data-id="element-380">
                Número de teléfono / WhatsApp
              </label>
              <input type="tel" name="telefono" required placeholder="+1 (000) 000-0000" className={inputClass} data-id="element-381" />
            </div>

            <div className="mb-5" data-id="element-382">
              <label className={labelClass} data-id="element-383">País de residencia</label>
              <select name="pais" required className={inputClass} defaultValue="" data-id="element-384">
                <option value="" disabled data-id="element-385">
                  Selecciona tu país
                </option>
                <option data-id="element-386">Venezuela</option>
                <option data-id="element-387">Colombia</option>
                <option data-id="element-388">México</option>
                <option data-id="element-389">Estados Unidos</option>
                <option data-id="element-390">España</option>
                <option data-id="element-391">Otro</option>
              </select>
            </div>

            {/* About the child */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-392">
              Sobre el Niño/a
            </p>

            <div className="mb-5" style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px'
          }} data-id="element-393">
              <div data-id="element-394">
                <label className={labelClass} data-id="element-395">Nombre del niño/a</label>
                <input type="text" name="nombre_nino" required placeholder="Nombre del niño o niña" className={inputClass} data-id="element-396" />
              </div>
              <div data-id="element-397">
                <label className={labelClass} data-id="element-398">Edad del niño/a</label>
                <input type="number" name="edad_nino" required placeholder="Edad en años" className={inputClass} data-id="element-399" />
              </div>
            </div>

            <div className="mb-5" data-id="element-400">
              <label className={labelClass} data-id="element-401">
                Diagnóstico actual (si tiene)
              </label>
              <input type="text" name="diagnostico" placeholder="Ej: TEA, TDAH, retraso del desarrollo, sin diagnóstico..." className={inputClass} data-id="element-402" />
            </div>

            <div className="mb-5" data-id="element-403">
              <label className={labelClass} data-id="element-404">
                ¿Cuánto tiempo lleva buscando ayuda?
              </label>
              <select name="tiempo_buscando" required className={inputClass} defaultValue="" data-id="element-405">
                <option value="" disabled data-id="element-406">
                  Selecciona una opción
                </option>
                <option data-id="element-407">Menos de 6 meses</option>
                <option data-id="element-408">Entre 6 meses y 1 año</option>
                <option data-id="element-409">Entre 1 y 3 años</option>
                <option data-id="element-410">Más de 3 años</option>
              </select>
            </div>

            {/* Current situation */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-411">
              Situación Actual
            </p>

            <div className="mb-6" data-id="element-412">
              <label className={labelClass} data-id="element-413">¿Qué tipo de ayuda necesita?</label>
              <div className="grid sm:grid-cols-2 gap-3 mt-2" data-id="element-414">
                {helpOptions.map(option => <label key={option} className="flex items-center gap-3 cursor-pointer text-[15px] text-[#333]" data-id="element-415">
                    <input type="checkbox" name="tipo_ayuda" value={option} className="w-5 h-5 accent-primary" data-id="element-416" />
                    {option}
                  </label>)}
              </div>
            </div>

            <div className="mb-5" data-id="element-417">
              <label className={labelClass} data-id="element-418">Cuéntanos tu situación</label>
              <textarea name="situacion" required rows={5} placeholder="Describe brevemente la situación de tu familia y cómo podemos ayudarte..." className="w-full px-4 py-3 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors resize-none" data-id="element-419" />
            </div>

            <div className="mb-8" data-id="element-420">
              <label className={labelClass} data-id="element-421">
                ¿Cómo se enteró de Pancita Feliz Foundation?
              </label>
              <select name="como_entero" required className={inputClass} defaultValue="" data-id="element-422">
                <option value="" disabled data-id="element-423">
                  Selecciona una opción
                </option>
                <option data-id="element-424">Redes sociales</option>
                <option data-id="element-425">Recomendación de un amigo</option>
                <option data-id="element-426">Médico o terapeuta</option>
                <option data-id="element-427">Búsqueda en internet</option>
                <option data-id="element-428">Otro</option>
              </select>
            </div>

            <button type="submit" className="w-full text-white font-bold rounded-xl transition-colors hover:bg-[#6ab518]" style={{
            height: '52px',
            fontSize: '16px',
            background: '#7DC920'
          }} data-id="element-429">
              Enviar Solicitud
            </button>

            <p className="text-center mt-4" style={{
            fontSize: '12px',
            color: '#888'
          }} data-id="element-430">
              🔒 Tu información es confidencial y será tratada con total
              privacidad
            </p>
          </form>
        </div>
      </section>
    </main>;
}